<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================ -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div v-if="$router.currentRoute.name != 'EditarAgendamentos'" class="dashboard-headline  margin-bottom-20" style="display: block;">
                    
                        <h3>
                            <i class="las" :class="$router.currentRoute.meta.icon"></i>
                            Agendar nova visita
                        </h3> 
                    </div>
                    <div v-if="$router.currentRoute.name == 'EditarAgendamentos'" class="dashboard-headline  margin-bottom-20" style="display: block;">
                    
                        <h3>
                            <i class="las" :class="$router.currentRoute.meta.icon"></i>
                            Detalhes da visita
                            <a v-if="form.status == 0" class="dashboard-status-button color-orange" style="display: inline-block; text-align: center; margin-top: 3px;">
                                Pendente
                            </a>
                            <a v-if="form.status == 1" class="dashboard-status-button color-blue" style="display: inline-block; text-align: center; margin-top: 3px;">
                                Em andamento
                            </a>
                            <a v-if="form.status == 2" class="dashboard-status-button color-green" style="display: inline-block; text-align: center; margin-top: 3px;">
                                Concluída
                            </a>
                            <a v-if="form.status == -1" class="dashboard-status-button color-red" style="display: inline-block; text-align: center; margin-top: 3px;">
                                Cancelada
                            </a>                                      
                        </h3>
                        <h5 class="padding-left-10 margin-top-10"><i class="las la-file"></i> <b>OS:</b> {{form.id}}</h5>       
                    </div>

                    <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">
                        <div class="row">
                            <div v-if="$root.user.tipo != 'contratante' && $router.currentRoute.name != 'EditarAgendamentos'" class="col-xl-12 margin-bottom-20">
                                <p class="help">
                                    <i class="las la-question-circle"></i>
                                    Preencha corretamente as informações abaixo para agendar uma nova visita avulsa.
                                </p>
                            </div>  

                            <div  v-if="$router.currentRoute.name == 'EditarAgendamentos'" class="col-xl-12 margin-bottom-20">
                                <button v-on:click="checkin" v-if="form.status == 0" type="button" class="button color-green block-mobile margin-bottom-10">
                                    <i class="las la-check-circle"></i>
                                    Fazer check-in
                                </button>
                                <button v-on:click="checkout" v-if="form.status == 1" type="button" class="button color-orange block-mobile margin-bottom-10">
                                    <i class="las la-sign-out-alt"></i>
                                    Fazer check-out
                                </button>
                                <button v-on:click="cancelar" v-if="form.status == 0" type="button" class="button color-red block-mobile margin-bottom-10">
                                    <i class="las la-ban"></i>
                                    Cancelar visita
                                </button>
                                <router-link :to="{'name': 'OS', 'query': {'c': form.cod}}" target="_blank" v-if="form.status == 2" type="button" class="button gray block-mobile margin-bottom-10">
                                    <i class="las la-file-contract"></i>
                                    Visualizar ordem de serviço
                                </router-link>                                                                  
                            </div>

                            <div class="col-xs-12 col-md-6 col-lg-5 col-xl-4" v-if="$router.currentRoute.name != 'EditarAgendamentos'">
                                <div class="submit-field margin-bottom-10">
                                    <h5>Cliente:</h5>
                                    <autocomplete ref="clienteNome" :search="searchAutocompleteCliente" placeholder="Pesquise o cliente aqui..." aria-label="Pesquise o cliente aqui (nome, CNPJ..)" :get-result-value="getResultAutocompleteCliente" @submit="submitAutocompleteCliente"></autocomplete>                                            
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6 col-lg-5 col-xl-4" v-if="$root.user.tipo == 'admin' && $router.currentRoute.name != 'EditarAgendamentos'">
                                <div class="submit-field margin-bottom-10">
                                    <h5>Equipe responsável:</h5>
                                    <select id="tecnico" class="with-border" readonly="" name="tecnico" required="" v-model="form.equipeCod" :disabled="$router.currentRoute.name == 'EditarAgendamentos'">
                                        <option value="" disabled selected="">
                                            Selecione..
                                        </option>
                                        <option v-for="(item, index) in equipes.itens" :key="item.cod" :value="item.cod">{{item.nome}}</option>
                                    </select>   
                                </div>
                            </div>

                            <!--  -->

                            <div class="col-xl-12 margin-bottom-20" v-if="$router.currentRoute.name == 'EditarAgendamentos' && form.cliente">
                                <div class="dashboard-box margin-top-0">
                                    <div class="content with-padding ">
                                        <div class="row">

                                            <div class="col-xs-12 col-md-6 col-lg-5 col-xl-5" v-if="$router.currentRoute.name == 'EditarAgendamentos'">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>
                                                        <i class="las la-clock"></i> Criada em:
                                                    </h5>
                                                    <p>{{form.datahora | formatDate}}</p>
                                                </div>
                                            </div>

                                            <div class="col-xs-12 col-md-6 col-lg-5 col-xl-5" v-if="$router.currentRoute.name == 'EditarAgendamentos'">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>
                                                        <i class="las la-clock"></i> Última atualização em:
                                                    </h5>
                                                    <p>{{form.atualizacao | formatDate}}</p>
                                                </div>
                                            </div>

                                            <div class="col-xs-12 col-md-6 col-lg-5 col-xl-5" v-if="$router.currentRoute.name == 'EditarAgendamentos'">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>
                                                        <i class="las la-check-circle"></i> Data/hora check-in:
                                                    </h5>
                                                    <p v-if="form.checkin != '0000-00-00 00:00:00'">{{form.checkin | formatDate}}</p>
                                                    <p v-if="form.checkin == '0000-00-00 00:00:00'">-</p>
                                                </div>
                                            </div>       

                                            <div class="col-xs-12 col-md-6 col-lg-5 col-xl-5" v-if="$router.currentRoute.name == 'EditarAgendamentos'">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>
                                                        <i class="las la-sign-out-alt"></i>
                                                        Data/hora check-out:
                                                    </h5>
                                                    <p v-if="form.checkout != '0000-00-00 00:00:00'">{{form.checkout | formatDate}}</p>
                                                    <p v-if="form.checkout == '0000-00-00 00:00:00'">-</p>
                                                </div>
                                            </div>                                                                                                                                    

                                            <div class="col-xs-12 col-md-6 col-lg-5 col-xl-5" v-if="$router.currentRoute.name == 'EditarAgendamentos'">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>
                                                        <i class="las la-user-friends"></i>
                                                        Cliente: <a v-if="$root.user.tipo == 'admin'" v-on:click="$root.go('EditarClientes', JSON.stringify({'c': form.clienteCod}))" style="text-decoration: underline; margin-left: 10px;"><i class="las la-edit"></i> Visualizar cliente</a>
                                                    </h5>
                                                    <p>{{form.cliente.empresa ? form.cliente.empresa : form.cliente.nome}}</p>
                                                </div>
                                            </div>
                                            <div class="col-xs-12 col-md-6 col-lg-5 col-xl-4" v-if="$root.user.tipo == 'admin' && $router.currentRoute.name == 'EditarAgendamentos'">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>
                                                        <i class="las la-users-cog"></i>
                                                        Equipe responsável: <a v-if="$root.user.tipo == 'admin'" v-on:click="$root.go('EditarEquipes', JSON.stringify({'c': form.equipeCod}))" style="text-decoration: underline; margin-left: 10px;"><i class="las la-edit"></i> Visualizar equipe</a>
                                                    </h5>
                                                    <p>{{form.equipe.nome}}</p>
                                                </div>
                                            </div>


                                            <div class="col-xl-12"></div>
                                            <div class="col-xl-5" v-if="form.cliente.cnpj">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>
                                                        <i class="las la-shield-alt"></i>
                                                        CNPJ:
                                                    </h5>
                                                    <p>{{form.cliente.cnpj}}</p>
                                                </div>
                                            </div>
                                            <div class="col-xl-5" v-if="form.cliente.doc && !form.cliente.cnpj">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>
                                                        <i class="las la-shield-alt"></i>
                                                        CPF:
                                                    </h5>
                                                    <p>{{form.cliente.doc}}</p>
                                                </div>
                                            </div>                                            

                                            <div class="col-xl-6">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>
                                                        <i class="las la-map-marker"></i>
                                                        Endereço completo:
                                                    </h5>
                                                    <p><a target="_blank" :href="'https://www.google.com/maps?q=' + form.cliente.endereco + ',' + form.cliente.numero + ',' + form.cliente.cep + ',' + form.cliente.bairro + ',' + form.cliente.cidade + ',' + form.cliente.estado + ',Brasil'">{{form.cliente.endereco}}, {{form.cliente.numero != '' ? form.cliente.numero : 's/n'}}. {{form.cliente.cep}}. {{form.cliente.bairro}}. {{form.cliente.cidade}} - {{form.cliente.estado}}</a></p>
                                                </div>
                                            </div>


                                            <div class="col-xl-5">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>
                                                        <i class="las la-tags"></i>
                                                        Categoria do cliente:
                                                    </h5>
                                                    <p v-if="!form.cliente.categoria">
                                                        -
                                                    </p>
                                                    <p v-if="form.cliente.categoria">
                                                        <span  class="dashboard-status-button color-gray">{{form.cliente.categoria}}</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-xl-6">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>
                                                        <i class="las la-map-marked-alt"></i>
                                                        Complemento:
                                                    </h5>
                                                    <p>{{form.cliente.complemento ? form.cliente.complemento : '-'}}</p>
                                                </div>
                                            </div>
                                            <div class="col-xl-5">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>
                                                        <i class="las la-envelope"></i>
                                                        E-mail do cliente:
                                                    </h5>
                                                    <p><a target="_blank" :href="'mailto:' + form.cliente.email" v-if="form.cliente.email">{{form.cliente.email}}</a></p>
                                                    <p><a target="_blank" :href="'mailto:' + item" v-for="(item, index) in form.cliente.emails">{{item}}<br></a></p>
                                                </div>
                                            </div>                                    
                                            <div class="col-xl-6">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>
                                                        <i class="las la-phone"></i>
                                                        Telefone do cliente:
                                                    </h5>
                                                    <p><a target="_blank" :href="'tel:' + form.cliente.telefone">{{form.cliente.telefone | telefone}}</a></p>
                                                    <p v-for="(item, index) in form.cliente.telefones"><a target="_blank" :href="'tel:' + item"  >{{item | telefone}}</a></p>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--  -->

                            <!-- <div class="col-xs-12"></div> -->

                            <div class="col-xs-8 col-md-6 col-lg-4 col-xl-3">
                                <div class="submit-field">
                                    <h5>
                                        Data de agendamento:
                                    </h5>
                                    <input v-bind:class="{'disabled': form.status > 0}" type="date" class="with-border" required="" v-model="form.data">
                                </div>
                            </div>
                            <div v-if="$router.currentRoute.name == 'EditarAgendamentos'" class="col-xs-12 col-md-6 col-lg-3">
                                <div class="submit-field">
                                    <h5>
                                        Status:
                                    </h5>
                                    <select id="tecnico" class="with-border" v-bind:class="{'disabled': true}" style="pointer-events: none !important; opacity: 0.5 !important;" disabled readonly="" name="tecnico" required="" v-model="form.status">
                                        <option value="" disabled selected="">
                                            Selecione..
                                        </option>
                                        <option value="0">
                                            Pendente
                                        </option>
                                        <option value="1">
                                            Em andamento
                                        </option>
                                        <option value="2">
                                            Concluída
                                        </option>
                                        <option value="-1">
                                            Cancelada
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="$router.currentRoute.name == 'EditarAgendamentos'" class="col-xs-12"></div>
                                                        
                            <div class="col-xl-12"></div>
                            <div class="col-xs-12 col-xl-6">
                                <div class="submit-field">
                                    <h5>
                                        Instruções:
                                    </h5>
                                    <textarea name="instrucoes" id="instrucoes" class="with-border" required=""  cols="30" rows="10" placeholder="Preencha as instruções..." v-model="form.instrucoes"></textarea>
                                </div>
                            </div>
                            <div class="col-xs-12 col-xl-6">
                                <div class="submit-field">
                                    <h5>
                                        Observações:
                                    </h5>
                                    <textarea name="observacoes" id="observacoes" class="with-border" required=""  cols="30" rows="10" placeholder="Preencha as informações sobre a visita..." v-model="form.observacoes"></textarea>
                                </div>
                            </div>
                            <div class="col-xl-12 scroll-to-fotos"></div>
                            <div v-if="$router.currentRoute.name == 'EditarAgendamentos'" class="col-xs-12 list margin-bottom-15 margin-top-10">
                                <h4>
                                    <i class="las la-camera" style="color: #000"></i>
                                    <b>
                                        Fotos da visita
                                    </b>
                                </h4>
                                <div class="row">
                                    <div v-if="$router.currentRoute.name == 'EditarAgendamentos'" class="col-xs-12 col-xl-3 margin-top-15 margin-bottom-10">
                                        <label for="upload" class="button color-gray block-mobile" style="text-align: center;">
                                            <i class="las la-images"></i>
                                            Adicionar fotos
                                            <input type="file" multiple="" v-on:change="getBase64Imagem" capture="environment" id="upload" accept="image/*" style="display: none !important;">
                                        </label>
                                    </div>
                                </div>
                                <div class="row galeria">
                                    <div v-for="(item, index) in form.arquivos" class="col-xs-6 col-xl-3 margin-bottom-10">
                                        <input type="text" name="" v-model="item.descricao" placeholder="Escreva observações aqui..">

                                        <a class="del" v-on:click="delImagem(item)">
                                            <i class="las la-times-circle"></i>
                                        </a>

                                        <a :href="item.link" target="_blank">
                                            <div :style="{'background-image': 'url(' + item.link + ')'}"></div>
                                        </a>
                                    </div>
                                                                                                                                
                                </div>
                            </div>

                            <div v-if="$router.currentRoute.name == 'EditarAgendamentos'" class="col-xs-12 itens margin-bottom-30 margin-top-10">
                                <h4>
                                    <i class="las la-list" style="color: #000"></i>
                                    <b>
                                        Itens da ordem de serviço
                                    </b>
                                </h4>                                
                                <table class="table table-bordered">
                                    <thead>
                                        <th>Item</th>
                                        <th style="width: 150px">Valor (R$)</th>
                                        <th style="width: 50px"></th>
                                    </thead>
                                    <tbody >
                                        <tr v-for="(item, index) in form.itens">
                                            <td style="padding: 0px">
                                                <input type="text" v-model="item.nome" class="with-border" placeholder="Escreva aqui...">
                                            </td>
                                            <td style="padding: 0px">
                                                <money v-model="item.valor" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-bind="$root.config.money" class="with-border"></money>
                                            </td>
                                            <td style="padding: 0px">
                                                <button v-on:click="delItem(item)" type="button" class="button color-red" style="margin-top: -12px; border-radius: 8px !important; height: 49px !important;">
                                                    <i class="las la-times"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <td colspan="2" style="padding: 0px; padding-bottom: 5px;">
                                            <button v-on:click="addItem" type="button" class="small button grey">Adicionar item</button>
                                        </td>

                                    </tbody>
                                </table>
                            </div>


                            <div class="col-xl-12 margin-bottom-30 margin-top-20">
                                <button type="submit" v-if="form.ativo == 1 || !form.cod" class="button button-lg color-green block-mobile margin-bottom-10" v-bind:class="{'disabled': loading.submit }">
                                    <i class="las la-save"></i>
                                    {{!form.cod ? 'Cadastrar agendamento' : 'Salvar informações'}}
                                </button>
                                <button v-if="$router.currentRoute.name == 'EditarAgendamentos'" type="button" v-on:click="del(form.cod)" class="button button-lg outline-gray block-mobile margin-bottom-10">
                                    <i class="las la-ban"></i>
                                    Excluir visita
                                </button>                                                
                            </div>
                          
                        </div>                
                    </form>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import AvatarCropper from "vue-avatar-cropper"

export default {
    name: 'GerenciarAgendamentos',
    components: {
        'AvatarCropper': AvatarCropper,
        'Top':      Top,
        'Sidebar':  Sidebar,
        'Toolbar':  Toolbar
    },          
    data () {
        var self                    = this;
        return {
            "salvo":                false,
            "loading": {
                "submit":           false
            },
            "equipes": {
                "itens":            []
            },
            "clientes": {
                "itens":            []
            },
            "form": {
                "_cod":             "",
                "_token":           "",
                "clienteCod":       "",
                "equipeCod":        "",
                "itens":            [],
                "status":           0,
                "data":             "",
                "hora":             "",
            }            
        }
    }, 
    filters: {
        telefone: function mask(v) {
              var r = v.replace(/\D/g, "");
              r = r.replace(/^0/, "");
              if (r.length > 10) {
                r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
              } else if (r.length > 5) {
                r = r.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "($1) $2-$3");
              } else if (r.length > 2) {
                r = r.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
              } else {
                r = r.replace(/^(\d*)/, "($1");
              }
              return r;
        },        
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toFixed(2).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0.00";
            }
        },        
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            return date + (time ? (" " + time) : "");
        }
    },         
    methods: {    
        submitAutocompleteCliente: function(obj) {
            console.log("submitAutocompleteCliente", obj)
            var self = this;
            self.form.clienteCod    = obj.cod;
            // self.form.cliente       = obj;
            self.$forceUpdate();
            console.log("Setou form", self.form)
        },        
        getResultAutocompleteCliente: function(result) {
          return (result.empresa ? result.empresa : result.nome);
        },            
        searchAutocompleteCliente: function(val, all) {
            var self = this;
            return new Promise(function(resolve, reject) {
                if (!val) {
                    resolve([]);
                    return false;
                }
    
                if (self.requestAutocomplete) {
                    self.requestAutocomplete.cancel(); 
                }

                self.requestAutocomplete = axios.CancelToken.source();  
                
                var form = {
                    "db":               "clientes",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "page":         1,
                        "autocomplete": true,
                        "all":          (all || false),
                        "pesquisa":     val
                    },
                    "cancelToken":      self.requestAutocomplete.token  
                };

                axios.get("api/clientes.php", form)
                .then(response => {
                    
                    resolve(response.data.result.itens);
  
                })
                .catch(error => {
                    loading.hide();
                    reject(error);
                }); 

            });
        },            
        addItem: function() {
            var self = this;
            self.form.itens.push({
                "nome": "",
                "valor": 0
            });
            self.$forceUpdate();
        },
        delItem: function(item) {
            var self = this;
            self.form.itens.splice(self.form.itens.indexOf(item), 1);
            self.$forceUpdate();
        },        
        delImagem: function(item) {
            console.log("delImagem()", item);
            var self = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                self.form.arquivos.splice(self.form.arquivos.indexOf(item), 1);
                self.$forceUpdate();
            });
        },        
        checkin: function() {
            console.log("checkin()");
            
            var self                = this;

            var request             = function() {
                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "cod":          self.form.cod,
                    "acao":         "checkin"
                };                

                loading.show();
                
                console.log("checkin() request", form);

                axios.put("api/visitas.php", form)
                .then(response => {
                    console.log("checkin() response", response)
                    loading.hide();
                    if (response.data.message) alert(response.data.message);
                    self.get(true);

                })
                .catch(error => {
                    console.log("checkin() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });                
            }

            confirm("Você tem certeza que deseja fazer check-in?", function() {
                request();
            });
        },  
        checkout: function() {
            console.log("checkout()");
            
            var self                = this;

            var request             = function() {
                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "cod":          self.form.cod,
                    "acao":         "checkout"
                };                

                loading.show();
                
                console.log("checkout() request", form);

                axios.put("api/visitas.php", form)
                .then(response => {
                    console.log("checkout() response", response)
                    loading.hide();
                    if (response.data.message) alert(response.data.message);
                    self.get(true);

                })
                .catch(error => {
                    console.log("checkout() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });                
            }

            confirm("Você tem certeza que deseja fazer check-out?", function() {
                request();
            });
        },    
        cancelar: function() {
            console.log("cancelar()");
            
            var self                = this;

            var request             = function() {
                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "cod":          self.form.cod,
                    "acao":         "cancelar"
                };                

                loading.show();
                
                console.log("cancelar() request", form);

                axios.put("api/visitas.php", form)
                .then(response => {
                    console.log("cancelar() response", response)
                    loading.hide();
                    if (response.data.message) alert(response.data.message);
                    self.get(true);

                })
                .catch(error => {
                    console.log("cancelar() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });                
            }

            confirm("Você tem certeza que deseja cancelar a visita?", function() {
                request();
            });
        },                           
        getBase64Imagem: function(event) {
            var self            = this;
            if (event.target.files.length > 0) {
                loading.show();
                var files = [...event.target.files];
                self.$root.sequence(files, function(item) {
                    return new Promise(function(resolve, reject) {
                        if (self.form.arquivos.length >= 10) {
                            reject("Erro! Você só pode enviar até 10 imagens.");
                        } else  {
                            reduceFileSize(item, 500*1024, 1000, Infinity, 0.9, blob => {
                                blobToBase64(blob, function(result) {
                                    // console.log("result", result);
                                    self.form.arquivos.push({
                                        "descricao":"",
                                        "link":     result
                                    });
                                    resolve(result);
                                });
                            }); 
                        }
                    }); 
                }).then(function(result) {

                    loading.hide();
                    console.log("getBase64Imagem() result", result);
                    self.$forceUpdate();

                }).catch(function(error) {
                    console.log("getBase64Imagem() error", error); 
                    loading.hide();
                    alert(error ? error : "Erro ao comprimir imagens");
                });
            }   
        },         
        escolherArquivo: function(campo) {
            console.log("escolherArquivo()", campo)
            var self = this;
            $(".uploadButton-button[for='upload-arquivo-" + campo + "']").click();        
         
        },             
        escolherImagem: function(campo) {
            console.log("escolherImagem()", campo)
            var self = this;
            $(".uploadButton-button[for='upload-arquivo-" + campo + "']").click();        
            
        },           
        submit: function(e) {
            var self            = this;
            // if (self.form.tipo != "admin" && self.form.tipo != "prestador") return false;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var form            = JSON.parse(JSON.stringify(self.form));

            if (self.form.itens.length == 1) {
                if (!self.form.itens[0].nome && !self.form.itens[0].valor) {
                    form.itens  = [];
                }
            }

            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            console.log("acao", a);

            axios[a]("api/visitas.php", form)
            .then(response => {
                
                self.salvo          = true;
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);

                if (!self.form.cod) {
                    self.$root.back();
                }
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        getClientes: function() {
            var self        = this;
            console.log("getClientes()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "all":          true,
                        "page":         1
                    }
                };

                axios.get("api/clientes.php", form)
                .then(response => {
                    
                    console.log("getClientes() response", response);
                    self.clientes       = response.data.result;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getClientes() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },
        getEquipes: function() {
            var self        = this;
            console.log("getEquipes()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "page":         1
                    }
                };

                axios.get("api/equipes.php", form)
                .then(response => {
                    
                    console.log("getEquipes() response", response);
                    self.equipes       = response.data.result;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEquipes() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/visitas.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form               = response.data.result;
                    self.form.instrucoes    = self.form.instrucoes.replaceAll('\\n','\n');
                    self.form.observacoes   = self.form.observacoes.replaceAll('\\n','\n');

                    if (self.form.itens.length == 0) {
                        self.form.itens     = [
                            {
                                "nome": "",
                                "valor": 0
                            }
                        ];
                    }

                    if (!self.loaded && self.$route.query.fotos) {
                        setTimeout(function() {

                            $(".dashboard-content-inner")[0].scrollTo({
                                top:            0
                            });                        
                            setTimeout(function() {
                                $(".dashboard-content-inner")[0].scrollTo({
                                    top:            $(".scroll-to-fotos")[0].getBoundingClientRect().top - (window.__app.mobile.isMobile ? 70 : 0),
                                    behavior:       "instant"
                                });             
                            }, 100);            
                        }, 500);
                    }

                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar?", function() {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          cod
                    }
                };
                loading.show();
                
                axios.delete("api/visitas.php", form)
                .then(response => {
                    console.log("del() response", response)
                    self.salvo          = true;
                    self.$root.back();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }               
    },    
    created: function() {
        var self = this;
        console.log("created", self);

    },
    activated: function() {
        var self = this;
        loading.show();
        if (self.$route.name == "EditarAgendamentos") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            loading.show();
            self.form.cod = self.$route.query.c;
            self.get();
        } else {
            self.getClientes();
            self.getEquipes();
        }
    },
    beforeRouteLeave (to, from, next) {
        var self = this;
        if (!self.salvo) {
            const answer = window.confirmWeb('Você tem certeza que deseja sair da página atual? Modificações não salvas podem ser perdidas.')
            if (!answer) return false;
        }
        next();
    }    
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .card .dashboard-status-button {
        margin-top: 8px;
    }

    .uploadButton-button {
        display: none !important;
    }        
    .button.gray.block-mobile {
        font-weight: 400;
        border: 1px solid #ddd !important;
    }

    .imagem-preview {
        width: 100%;
        height: 35vh;
        border-radius: 10px;
        margin-bottom: 25px !important;
        background-size: contain;
        background-color: #ddd;
        background-position: center;
        background-repeat: no-repeat;
    }    

    .uploadButton .uploadButton-input {
        opacity: 0 !important;
    }

    .submit-field p a {
        text-decoration: underline;
    }
    .submit-field p {
        color: #000 !important;
        font-weight: 600 !important;
        margin-bottom: 0px;
    }

    .dashboard-headline h5 {
        margin-bottom: 2px;
    }
    .dashboard-headline h5 b {
        font-weight: 700 !important;
    }

    .galeria input {
        height: 30px !important;
        padding-left: 5px;
        margin-bottom: 0px !important;
        border-bottom: 0px !important;
        border-bottom-left-radius: 0px !important;
        border-bottom-right-radius: 0px !important;
    }

    .galeria .col-xs-6 div {
        background-size: contain; 
        background-color: #efefef; 
        background-position: center; 
        height: 150px; 
        width: 100%; 
        background-repeat: no-repeat; 
        border: 2px solid rgb(54 53 55 / 50%) !important;        
    }

    .galeria .del {
        position: absolute;
        right: 15px;
        top: 3px;
        color: red;
        font-size: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/GerenciarAgendamentos.vue